export default __webpack_public_path__ + "static/media/DESIGN_PATTERNS_COVER_NO_EDGES_800_PX.8aa29899.jpg";